<template>
  <div>
    <el-form ref="formRef" :model="resumeForm" label-width="130px">
<!--      <el-form-item label="昵称：">-->
<!--        <el-input v-model="resumeForm.nickName" placeholder="请输入昵称" style="width: 26em"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="所在地：">-->
<!--        <el-select v-model="province" placeholder="Select" style="width: 12.5em;margin-right: 1em" @change="changeCity" >-->
<!--          <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--        <el-select v-model="city" placeholder="Select" style="width: 12.5em">-->
<!--          <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="出生日期：">
        <el-date-picker v-model="resumeForm.sysBirthday" type="date" placeholder="请选择日期" value-format="YYYY-MM-DD" style="width: 26em"/>
      </el-form-item>
      <el-form-item label="身高：">
        <el-select v-model="resumeForm.height" placeholder="">
          <el-option v-for="item in heightArray" :key="item.id" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio v-model="resumeForm.sex" :label="1" >男</el-radio>
        <el-radio v-model="resumeForm.sex" :label="2" >女</el-radio>
      </el-form-item>
      <el-form-item label="归属地城市：">
        <el-radio v-model="resumeForm.userSetting.ipShow" :label="0" >IP</el-radio>
        <el-radio v-model="resumeForm.userSetting.ipShow" :label="1" >现居城市</el-radio>
      </el-form-item>
<!--      <el-form-item label="个性签名：">-->
<!--        <el-input type="textarea" v-model="resumeForm.sign" :autosize="{ minRows: 4, maxRows: 8 }" placeholder="请输入个性签名" style="width: 26em"/>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="距离展示：">-->
<!--        <el-radio v-model="resumeForm.distanceShowState" :label="0" >是：实际坐标</el-radio>-->
<!--        <el-radio v-model="resumeForm.distanceShowState" :label="1" >是：所在地默认坐标</el-radio>-->
<!--        <el-radio v-model="resumeForm.distanceShowState" :label="2" >否</el-radio>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="城市IP：">-->
<!--        <el-radio v-model="resumeForm.ipConvertCity" :label="0" >允许更新</el-radio>-->
<!--        <el-radio v-model="resumeForm.ipConvertCity" :label="1" >不允许更新</el-radio>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="真人认证：">-->
<!--        <el-select v-model="resumeForm.baiduMatchState" placeholder="Select" style="width: 26em">-->
<!--          <el-option v-for="item in baiduMatchStateList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="实名认证：">-->
<!--        <el-select v-model="resumeForm.baiduAuthState" placeholder="Select" style="width: 26em">-->
<!--          <el-option v-for="item in baiduAuthStateList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="绑定渠道：">-->
<!--        <el-select v-model="resumeForm.channelId" placeholder="Select" style="width: 26em">-->
<!--          <el-option v-for="item in channelIdArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-bottom: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData} from "@/api/api";
import {areaList, channelList, updateResumeInfo} from "@/api/url";

export default {
name: "updateResumeDialog",
  props: {
    value: Object
  },
  data() {
    return {
      resumeForm: this.value.resumeForm,
      // province: this.value.resumeForm.province,
      // city: this.value.resumeForm.city,
      // provinceList: [],
      // cityList: [],
      heightArray: [],

      loading: false,


      // //真人
      // baiduMatchStateList: [
      //   {label: '未认证', value: 0},
      //   {label: '已认证', value: 1},
      //   {label: '认证失败', value: 2},
      // ],
      //
      // //实名
      // baiduAuthStateList: [
      //   {label: '未认证', value: 0},
      //   {label: '已认证', value: 1},
      //   {label: '认证失败', value: 2},
      // ],

      // channelIdArray: [],
      // iosList: [],
      // androidList: [],
      // // channelId: -1,
      // channel: '',

    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },

    // changeCity() {
    //   this.cityList = []
    //   for(let i=0; i<this.provinceList.length; i++) {
    //     if (this.province == this.provinceList[i].province) {
    //       let citys = this.provinceList[i].cityList
    //       citys.forEach(item => {
    //         let obj = {}
    //         obj.label = item.city
    //         obj.value = item.city
    //         this.cityList.push(obj)
    //       })
    //     }
    //   }
    //   this.city = this.cityList[0].value
    // },
    //
    // getAreaList() {
    //   getFormData(areaList).then((data)=>{
    //     let {msg, code} = data
    //     if (code == 200) {
    //       let dataList = data.data
    //       dataList.forEach(item => {
    //         item.label = item.province
    //         item.value = item.province
    //       })
    //       this.provinceList = dataList;
    //       for(let i=0; i<this.provinceList.length; i++) {
    //         if (this.province == this.provinceList[i].province) {
    //           let citys = this.provinceList[i].cityList
    //           citys.forEach(item => {
    //             let obj = {}
    //             obj.label = item.city
    //             obj.value = item.city
    //             this.cityList.push(obj)
    //           })
    //         }
    //       }
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   })
    // },

    summit() {
      this.$confirm('确认修改用户【' + this.resumeForm.nickName + '】的简历资料？', {
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let param = {};
        param['id'] = this.resumeForm.userId;
        param['sex'] = this.resumeForm.sex;
        param['ipShow'] = this.resumeForm.userSetting.ipShow;
        param['height'] = this.resumeForm.height;
        param['sysBirthday'] = this.resumeForm.sysBirthday;
        postFormData(updateResumeInfo, param).then((data) => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm', param)
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      })
    },

    // getChannelList() {
    //   getFormData(channelList).then((data)=>{
    //     let {msg, code} = data;
    //     if(code == 200) {
    //       let dataList = data.data;
    //       dataList.forEach(item=>{
    //         let obj = {}
    //         obj.label = item.channel
    //         obj.value = item.id
    //         if(item.platformType == 1) {
    //           this.androidList.push(obj)
    //         }else {
    //           this.iosList.push(obj)
    //         }
    //       })
    //       this.channelIdArray = [...this.channelIdArray, ...this.iosList, ...this.androidList]
    //     }else{
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   })
    // }

  },
  mounted() {
    for(let i = 145; i <= 200; i++) {
      this.heightArray.push({
        value: i,
        label: i
      })
    }
    // this.getAreaList()
    // this.getChannelList();
  }
}
</script>

<style scoped>

</style>
